






























































































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { DOMAIN_INFO_REQUIRED_PRODUCTS, STEPS, TRY_NOW_PRODUCTS_IDS, isValidCSEOrgName, isValidCasbFriendlyName, isCSEOrgNameLengthValid, isCSEOrgStartsWith } from '../constant';
import { InfoState } from '../../../core';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { required } from 'vuelidate/lib/validators';
import { SwFormRowError } from '@sonicwall/unified-ui-framework/src/shared/sw-form';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { FreetrialsDataCenter, FreetrialsDataCenters, FreetrialsSteps } from '../types';
import _ from 'lodash';
import { envCongif } from '@/shared/env.config';

const cssPrefix: string = 'tryNowComponent';
@Component({
  components : {
    ...UUIFComponents,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwFormRowError,
  },
  validations: {
    friendlyNameOrDomainName: { required, domainNameValid: isValidCasbFriendlyName },
    orgName: { required, orgNameValid: isValidCSEOrgName, orgNameLength: isCSEOrgNameLengthValid, orgNameStartsWith: isCSEOrgStartsWith },
  },
})
export default class TryNowComponent extends SwExtendedVue {
  cssPrefix: string = cssPrefix;
  @Prop({ type: String, default: '', required: true })
  readonly productId: any;

  @Prop({ type: String, default: '', required: true })
  readonly serviceId: any;

  @Prop({ type: String, default: '' })
  readonly widgetTitle: string;

  @Prop({ type: Boolean, default: false, required: true })
  readonly showTryNowDialog: any;

  @Prop({ type: Array, default: [], required: true })
  readonly productGroupList: any;

  dataCenterList: SelectOption[] = [];
  casbApplications: SelectOption[] = [];

  selectedDataCenter: string = '';
  selectedCasbApplication: string = '';
  selectedTenant: string = '';
  friendlyNameOrDomainName: string = '';
  currentStep: String = STEPS.ENTER_FRIENDLY_NAME_OR_DOMAIN_NAME_STEP;
  STEPS: FreetrialsSteps = { ...STEPS };
  orgName: string = '';
  cseAutoRedirect: string;

  created() {
    this.selectedTenant = this.productGroupList.length > 0 && this.productGroupList[0]?.id || '';
    this.$store.dispatch('getAppVersion')
    .then((result: any) => {
      this.cseAutoRedirect = result.content.cseAutoRedirect;
    });
  }

  mounted() {
    this.$nextTick(() => {
      !this.isDomainInformationRequired && this.makeFocus('friendlyname');
      this.isDomainInformationRequired && this.makeFocus('domainname');
    });
    document.addEventListener('keydown', this.onPressEnter);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.onPressEnter);
  }

  get getModalTitle() {
    if (this.serviceId !== '') {
      if (this.productId === TRY_NOW_PRODUCTS_IDS.CLOUD_EMAIL_SECURITY) {
        return this.$t('freetrial.provideces')
          .toString();
      }
      if (this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_EDGE) {
        return this.$t('freetrial.provideSASE')
          .toString();
      }
      if (this.productId === TRY_NOW_PRODUCTS_IDS.THERON
        || this.productId === TRY_NOW_PRODUCTS_IDS.THERON_MDR) {
        return this.$t('freetrial.provideTSE')
          .toString();
      }
      if (this.productId === TRY_NOW_PRODUCTS_IDS.CAPTURE_CLIENT) {
        return this.$t('freetrial.providecc')
          .toString();
      }
      if (this.productId === TRY_NOW_PRODUCTS_IDS.CLOUD_APP_SECURITY_BROKER) {
        return this.$t('freetrial.providecasb')
          .toString();
      }
      if (this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_AI) {
        return this.widgetTitle.toString();
      }
      if (this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_SECURE_EDGE) {
        return this.$t('freetrails.provideCSE').toString();
      }
      return this.$t('freetrial.provideces')
        .toString();
    }
    return this.$t('freetrial.provideFriendlyName')
      .toString();
  }

  get isDomainInformationRequired() {
    return DOMAIN_INFO_REQUIRED_PRODUCTS.includes(this.productId);
  }

  get isCaptureClientProduct() {
    return TRY_NOW_PRODUCTS_IDS.CAPTURE_CLIENT === this.productId;
  }

  get isCloudSecureEdgeProduct() {
    return TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_SECURE_EDGE === this.productId;
  }

  get isSAMI() {
    return TRY_NOW_PRODUCTS_IDS.SONICWALL_AI === this.productId;
  }

  get getDomainName() {
    if (this.productId === TRY_NOW_PRODUCTS_IDS.CLOUD_APP_SECURITY_BROKER) {
      return '.sonicwallcloudsec.com';
    }
    return '.SonicWallEdge.com';
  }

  get getCASDataCenters(): SelectOption[] {
    return this.dataCenterList || [];
  }

  get getCASApplications(): SelectOption[] {
    return this.casbApplications || [];
  }

  get getProductGroupList(): SelectOption[] {
    return this.productGroupList || [];
  }

  get showTermsandConditions(): boolean {
    return this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_EDGE;
  }

  get termsandConditionsLink(): string {
    return 'https://www.sonicwall.com/legal/sonicwall-cloud-edge-secure-access-agreement/';
  }

  get isOrgNameRequired(): boolean {
    return this.$v!.orgName!.$dirty && !this.$v!.orgName!.required;
  }

  get isOrgNameInValid(): boolean {
    return this.$v!.orgName!.$dirty && !this.$v!.orgName!.orgNameValid;
  }

  get isOrgNameLengthInvalid(): boolean {
    return this.$v!.orgName!.$dirty && !this.$v!.orgName!.orgNameLength;
  }

  get isOrgNameStartsWith(): boolean {
    return this.$v!.orgName!.$dirty && !this.$v!.orgName!.orgNameStartsWith;
  }

  get getOrgNameErrorMessage() {
    let message: any = '';

    if (this.isOrgNameInValid) {
      message = this.$t('freetrails.cseNameInvalid');
    }
    if (this.isOrgNameStartsWith) {
      message = this.$t('freetrails.cseNameStartsWith');
    }
    if (this.isOrgNameLengthInvalid) {
      message = this.$t('freetrails.cseNameLengthError');
    }
    if (this.isOrgNameRequired) {
      message = this.$t('freetrails.cseNameRequired');
    }

    return message;
  }

  get checkFormError(): boolean {
    if (this.currentStep === STEPS.ENTER_FRIENDLY_NAME_OR_DOMAIN_NAME_STEP && !this.isCaptureClientProduct && !this.isSAMI) {
      if (this.isCloudSecureEdgeProduct) {
        return false;
      }
      this.$v!.friendlyNameOrDomainName!.$touch();
      if (this.isDomainNameRequired) {
        return this.isDomainNameRequired || this.isDomainNameInvalid;
      }
      return this.isFriendlyNameRequired;
    }
    if (this.currentStep === STEPS.CHOOSE_DATA_CENTER_AND_SUB_DOMAIN_NAME_STEP) {
      this.$v!.orgName!.$touch();
      if (this.isOrgNameRequired) {
        return true;
      }
      if (this.isOrgNameInValid) {
        return true;
      }
      if (this.isOrgNameLengthInvalid) {
        return true;
      }
      if (this.isOrgNameStartsWith) {
        return true;
      }
    }
    return false;
  }

  get isFriendlyNameRequired() {
    return this.$v!.friendlyNameOrDomainName!.$dirty && !this.$v!.friendlyNameOrDomainName!.required;
  }

  get isDomainNameRequired() {
    return this.$v!.friendlyNameOrDomainName!.$dirty && !this.$v!.friendlyNameOrDomainName!.required;
  }

  get isDomainNameInvalid() {
    return this.$v!.friendlyNameOrDomainName!.$dirty &&
      !this.$v!.friendlyNameOrDomainName!.domainNameValid &&
      this.friendlyNameOrDomainName !== '';
  }

  get getSubdomainAppName() {
    if (TRY_NOW_PRODUCTS_IDS.CLOUD_APP_SECURITY_BROKER === this.productId) {
      return 'SonicWall Cloud App Security';
    }
    return  'Sonicwall Cloud Edge';
  }

  get groupName() {
    const group = this.productGroupList.find((group: any) => group.id === this.selectedTenant);
    return group ? group.label : undefined;
  }

  makeFocus(ref: string) {
    if (this.$refs[ref]) {
      ((this.$refs[ref] as SwTextfield).$refs.input as HTMLElement).focus();
    }
  }

  onPressEnter(e: KeyboardEvent) {
    if (e.code === 'Enter') {
      this.tryNow();
    }
    e.stopImmediatePropagation();
  }

  setDatacentersOptions(datacenters: FreetrialsDataCenters): void {
    if (datacenters.length > 0) {
      const tempList = datacenters.map((dataCenter: FreetrialsDataCenter) => {
        return {
          id: dataCenter.dataCenterId,
          label: dataCenter.dataCenterDesc,
          value: dataCenter.dataCenterId,
        };
      });
      this.dataCenterList = _.cloneDeep(tempList);
      this.selectedDataCenter = this.dataCenterList[0]?.id || '';
    }
  }

  fetchCASDataCenters(serviceId: any, productID: any) {
    const request = { serviceId, productID };
    this.$store.dispatch('MswProductsStoreModule/getCASDataCenter', request)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK' && resp.msgCode ===  'MSWAPP:SUCCESS') {
          const dataCenterList = resp.content?.dataCenter || [];
          this.dataCenterList = dataCenterList.map((dataCenter: any) => {
            return  {
              id: dataCenter.dataCenterId,
              label: dataCenter.dataCenterDesc,
              value: dataCenter.dataCenterId,
            };
          });
          this.selectedDataCenter = this.dataCenterList.length > 0 && this.dataCenterList[0]?.id || '';
        }
      })
      .catch((err:any) => {
        console.error(err);
        this.showMessage(
          'failed',
          this.$t('systemMessages.wrong')
          .toString(),
        );
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  public tryNow() {
    if (this.checkFormError) {
      return;
    }
    let data: any = {};
    if (this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_CLIENT_LICENSE_PRODUCT ||
      this.productId === TRY_NOW_PRODUCTS_IDS.CLOUD_APP_SECURITY_BROKER ||
      this.serviceId === '6520' ||
      this.serviceId === '6560' ||
      this.productId === TRY_NOW_PRODUCTS_IDS.CAPTURE_CLIENT) {
      data = {
        clientDistGroup: this.friendlyNameOrDomainName && this.friendlyNameOrDomainName?.trim() || '',
        productId: this.productId,
        serviceId: this.serviceId,
        productGroupId: this.selectedTenant,
        casbDataCenter: this.selectedDataCenter,
        casApplicationId: this.selectedCasbApplication,
      };
    } else if (this.productId === TRY_NOW_PRODUCTS_IDS.THERON) {
      data = {
        clientDistGroup: this.friendlyNameOrDomainName && this.friendlyNameOrDomainName?.trim() || '',
        productId: this.productId,
        serviceId: this.serviceId,
        productGroupId: this.selectedTenant,
        casbDataCenter: this.selectedDataCenter,
        casApplicationId: '',
      };
    } else if (this.productId === TRY_NOW_PRODUCTS_IDS.THERON_MDR) {
      data = {
        clientDistGroup: this.friendlyNameOrDomainName && this.friendlyNameOrDomainName?.trim() || '',
        productId: this.productId,
        serviceId: this.serviceId,
        productGroupId: this.selectedTenant,
        casbDataCenter: this.selectedDataCenter,
        casApplicationId: '',
      };
    } else if (this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_EDGE) {
      data = {
        clientDistGroup: this.friendlyNameOrDomainName && this.friendlyNameOrDomainName?.trim() || '',
        productId: this.productId,
        serviceId: this.serviceId,
        productGroupId: this.selectedTenant,
        casbDataCenter: this.selectedDataCenter,
        casApplicationId: '',
      };
    } else if (this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_AI) {
      this.friendlyNameOrDomainName = `${this.widgetTitle} - ${this.groupName}`;
      data = {
        clientDistGroup: this.friendlyNameOrDomainName && this.friendlyNameOrDomainName?.trim() || '',
        productId: this.productId,
        serviceId: this.serviceId,
        productGroupId: this.selectedTenant,
        casbDataCenter: this.selectedDataCenter,
        casApplicationId: '',
      };
    } else if (this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_SECURE_EDGE) {
      this.friendlyNameOrDomainName = `Cloud Secure Edge - ${this.groupName}`;
      data = {
        clientDistGroup: this.friendlyNameOrDomainName && this.friendlyNameOrDomainName?.trim() || '',
        productId: this.productId,
        serviceId: this.serviceId,
        productGroupId: this.selectedTenant,
        casbDataCenter: this.selectedDataCenter,
        casApplicationId: '',
        subDomain: this.orgName || '',
      };
    } else {
      data = {
        productId: this.productId,
        serviceId: this.serviceId,
        clientDistGroup: this.friendlyNameOrDomainName,
        productGroupId: this.selectedTenant,
      };
    }
    this.$store
      .dispatch('MswProductsStoreModule/tryNowApi', data)
      .then((resp:any) => {
        if (resp.operationStatus === 'OK') {
          this.$store.commit('stopLoading');
          if (resp.msgCode === 'MSWAPP:NEEDCASBDATACENTER') {
            this.fetchCASDataCenters(this.serviceId, this.productId);
            this.currentStep = STEPS.CHOOSE_DATA_CENTER_STEP;
          } else if (resp.msgCode === 'MSWAPP:NEEDCASAPP') {
            this.casbApplications = resp?.content?.casbAppList || [];
            this.currentStep = STEPS.CHOOSE_CASB_APP_STEP;
          } else if (resp.msgCode === 'MSWAPP:NEEDTSEDATACENTER'
            || resp.msgCode === 'MSWAPP:NEEDTSEMDRDATACENTER') {
            this.fetchCASDataCenters(this.serviceId, this.productId);
            this.currentStep = STEPS.CHOOSE_DATA_CENTER_STEP;
          } else if (resp.msgCode === 'MSWAPP:NEEDCSEDATACENTER') {
            this.setDatacentersOptions(resp?.datacenters);
            this.currentStep = STEPS.CHOOSE_DATA_CENTER_AND_SUB_DOMAIN_NAME_STEP;
          } else if (resp.msgCode === 'MSWAPP:NEEDSASEDATACENTER') {
            if (resp?.datacenters &&
              resp?.datacenters.length === 1 &&
              this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_EDGE) {
              this.selectedDataCenter = resp?.datacenters[0]?.dataCenterId || '';
              this.tryNow();
            } else {
              this.fetchCASDataCenters(this.serviceId, this.productId);
              this.currentStep = STEPS.CHOOSE_DATA_CENTER_STEP;
            }
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            if (this.cseAutoRedirect === 'YES' && this.productId === TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_SECURE_EDGE) {
              const request = {
                tenant: this.selectedTenant,
                tileName: 'ISMSWSAFEENABLED',
              };
              this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
              .then((resp: any) => {
                if (resp?.msgCode === 'MSWAPP:GENERATECSCACCESSCODESUCCESS') {
                  const cscAccessCode = resp?.content?.accessCode;
                  window.open(`${envCongif.spog_url}/muir/spog/login?code=${encodeURIComponent(cscAccessCode)}&mode=tileclick&stile=CSE&tenantid=${this.selectedTenant}`, '_blank');
                }
              })
              .catch((err: any) => {
                this.$store.commit('stopLoading');
                console.error(err);
              })
              .finally(() => {
                this.$store.commit('stopLoading');
              });
            }
            setTimeout(() => {
              this.$emit('callSuccess', resp);
            }, 500); // tslint:disable-line
          }
        } else {
          this.$store.commit('stopLoading');
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
      })
      .catch((errMessage) => {
        console.error(errMessage);
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong. Please try after sometime' });
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  public closeDialog() {
    this.orgName = '';
    this.$emit('closeDialog');
  }

  private showMessage(infoType: string, infoMsg: string): void {
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
